import { HttpClient } from "@angular/common/http";
import { SnackbarService } from "app/core/snackbars/snackbar.service";
import { catchError, Observable, ReplaySubject } from "rxjs";
import { PaginatedList, PaginationFilter } from "app/core/pagination/pagination.types";
import { Injectable } from "@angular/core";
import { getPaginationParams } from "app/core/pagination/pagination.utils";
import { CreateUser, User, UpdateUser } from "./user.types";
import { Role } from "app/core/roles/role.types";

@Injectable({
    providedIn: 'root',
})
export class UserService {
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);

    constructor(
        private _httpClient: HttpClient,
        private _snackbarService: SnackbarService,
    ) {
    }

    set user(value: User) {
        this._user.next(value);
    }

    get user$(): Observable<User> {
        return this._user.asObservable();
    }

    createUser(request: CreateUser): Observable<string> {
        return this._httpClient.post<string>('api/users', request).pipe(
            catchError((err, _) => {
                this._snackbarService.error(err);
                throw err;
            }));
    }

    updateUser(request: UpdateUser): Observable<void> {
        return this._httpClient.put<void>(`api/users/${request.id}`, request).pipe(
            catchError((err, _) => {
                this._snackbarService.error(err);
                throw err;
            }));
    }

    deleteUser(id: string): Observable<void> {
        return this._httpClient.delete<void>(`api/users/${id}`).pipe(
            catchError((err, _) => {
                this._snackbarService.error(err);
                throw err;
            }));
    }

    getUsers(filter: PaginationFilter): Observable<PaginatedList<User>> {
        const params = getPaginationParams(filter);

        return this._httpClient.get<PaginatedList<User>>('api/users', { params }).pipe(
            catchError((err, _) => {
                this._snackbarService.error(err);
                throw err;
            }));
    }

    getUser(id: string): Observable<User> {
        return this._httpClient.get<User>(`api/users/${id}`).pipe(
            catchError((err, _) => {
                this._snackbarService.error(err);
                throw err;
            }));
    }

    getUserRoles(id: string): Observable<Role[]> {
        return this._httpClient.get<Role[]>(`api/users/${id}/roles`).pipe(
            catchError((err, _) => {
                this._snackbarService.error(err);
                throw err;
            }));
    }
}